import { render, staticRenderFns } from "./ReferralList.vue?vue&type=template&id=63a16e96&scoped=true&"
import script from "./ReferralList.vue?vue&type=script&lang=js&"
export * from "./ReferralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a16e96",
  null
  
)

export default component.exports